import React, { useEffect, useState } from "react";
import "./BackToTop.css";

const BackToTop = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // 👉 400px dan keyin chiqadi (sen so‘ragan)
            setVisible(window.scrollY > 100);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return (
        visible && (
            <button className="back-to-top" onClick={scrollToTop}>
                ⬆
            </button>
        )
    );
};

export default BackToTop;